import React, { useState, useEffect, lazy, Suspense } from 'react';
import AnimatedCursor from 'react-animated-cursor';
import './styles/_scss/main.scss';

import Home from './pages/Home/Home';
import Footer from './components/Sections/Footer';
import Navigation from './components/Navigation/Navigation';
import BannerCookieConsent from './components/Sections/BannerCookieConsent';

const LegalPage = lazy(() => import('./pages/Legal/Legal'));

function App() {
  const [showLegalPage, setShowLegalPage] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showBannerCookieContent, setShowBannerCookieContent] = useState(true);

  useEffect(() => {
    const checkIfMobile = () => {
      const isMobileDevice = window.matchMedia('(max-width: 1024px)').matches;
      setIsMobile(isMobileDevice);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  const handleShowLegalPage = (e) => {
    e.preventDefault();
    setShowLegalPage(true);
    setTimeout(() => {
      const legalPage = document.getElementById('legal-page');
      if (legalPage) {
        legalPage.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500);
  };

  const handleHideLegalPage = (e) => {
    e.preventDefault();
    setShowLegalPage(false);
    setTimeout(() => {
      const legalPage = document.getElementById('legal-page');
      if (legalPage) {
        legalPage.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500);
  };

  return (
    <>
      {!isMobile && (
        <AnimatedCursor
          color={'23, 248, 140'}
          innerSize={8}
          outerSize={35}
          innerScale={1}
          outerScale={1.7}
          outerAlpha={0.3}
          outerStyle={{
            mixBlendMode: 'exclusion',
          }}
        ></AnimatedCursor>
      )}

      <Suspense fallback={<div></div>}>
        {showLegalPage ? (
          <LegalPage handleHideLegalPage={handleHideLegalPage} />
        ) : (
          <>
            <Navigation />
            <Home />
            <Footer handleShowLegalPage={handleShowLegalPage} />
            <BannerCookieConsent
              setShowBannerCookieContent={setShowBannerCookieContent}
              setShowLegalPage={setShowLegalPage}
            />
          </>
        )}
      </Suspense>
    </>
  );
}

export default App;
